module.exports = [
    ['top_1', './data/animations/top_1.json'],
    ['bottom_1', './data/animations/bottom_1.json'],
    ['start', './data/animations/startAdaptive_with_girl.json'],
    ['start_forest_l1', './data/animations/start_forest_layer1.json'],
    ['start_forest_l2', './data/animations/start_forest_layer2.json'],
    // ['start_girl', './data/animations/start_girl.json'],
    ['start_front', './data/animations/start_front.json'],
    ['forest', './data/animations/forest_v5.json'],
    ['forest_front', './data/animations/forest_front.json'],
    ['mountains', './data/animations/mountains_v5.json'],
    ['mountains_back', './data/animations/mountains_back_v3.json'],
    ['river', './data/animations/river_v4.json'],
    ['mountains_front', './data/animations/mountains_front_v2.json'],
    ['river_front', './data/animations/river_front_v2.json']
];
